/* fk-nav-desktop: dropdowns open on hover and on click/Enter/Space; close on Escape, outside click, focus leaving. */
(function () {
  var nav = document.querySelector('.fk-nav');
  if (!nav) return;
  var items = Array.prototype.slice.call(nav.querySelectorAll('.fk-nav__item')).filter(function (li) { return li.querySelector('.fk-nav__panel'); });
  var hoverQuery = window.matchMedia('(hover: hover)');
  var timers = new WeakMap();

  function parts(li) { return { btn: li.querySelector('.fk-nav__trigger'), panel: li.querySelector('.fk-nav__panel') }; }
  function open(li, viaHover) {
    clearTimeout(timers.get(li));
    li.dataset.byHover = viaHover ? '1' : '0';
    items.forEach(function (o) { if (o !== li) close(o); });
    var p = parts(li); p.panel.hidden = false; p.btn.setAttribute('aria-expanded', 'true');
  }
  function close(li) {
    clearTimeout(timers.get(li));
    var p = parts(li); p.panel.hidden = true; p.btn.setAttribute('aria-expanded', 'false');
  }
  function isOpen(li) { return parts(li).btn.getAttribute('aria-expanded') === 'true'; }

  items.forEach(function (li) {
    var p = parts(li);
    p.btn.addEventListener('click', function () {
      /* A click while the menu is only hover-open pins it open; a second click closes it. */
      if (isOpen(li) && li.dataset.byHover === '1') { li.dataset.byHover = '0'; return; }
      isOpen(li) ? close(li) : open(li, false);
    });
    li.addEventListener('mouseenter', function () { if (hoverQuery.matches && !isOpen(li)) open(li, true); });
    li.addEventListener('mouseleave', function () {
      if (!hoverQuery.matches || li.dataset.byHover === '0') return;
      timers.set(li, setTimeout(function () { close(li); }, 120));
    });
    li.addEventListener('focusout', function (e) {
      if (!li.contains(e.relatedTarget)) close(li);
    });
    li.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen(li)) { e.preventDefault(); close(li); p.btn.focus(); }
      if (e.key === 'ArrowDown' && document.activeElement === p.btn) {
        e.preventDefault(); open(li);
        var first = p.panel.querySelector('a'); if (first) first.focus();
      }
    });
  });
  /* Narrower than the desktop breakpoint (990px): the bar is hidden by CSS, so make sure no panel is left open for when it comes back. */
  var narrow = window.matchMedia('(max-width: 989px)');
  var closeAllIfNarrow = function () { if (narrow.matches) items.forEach(close); };
  if (narrow.addEventListener) narrow.addEventListener('change', closeAllIfNarrow); else if (narrow.addListener) narrow.addListener(closeAllIfNarrow);
  window.addEventListener('resize', closeAllIfNarrow);
  document.addEventListener('click', function (e) { if (!nav.contains(e.target)) items.forEach(close); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') items.forEach(close); });
})();
